import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ClassificationPillComponent } from './classification-pill.component';

// Shared PlateX classification pill (build pack §8). Declared in its own
// module — the plate.module / main-nav-chips.module pattern — so every
// surface (AppModule pages, PlateDetailV2Module, future reference pages)
// imports one identical implementation.
@NgModule({
  declarations: [ClassificationPillComponent],
  imports: [CommonModule, RouterModule],
  exports: [ClassificationPillComponent],
})
export class ClassificationPillModule {}
